import { HttpClient, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiRequestService, LogService, UseCase, Void } from '@prekog/common-ui';
import { Observable } from 'rxjs';
import { SiteConfiguration } from '../../shared/models/site-configuration.model';
import { UpdateSiteConfigRequest } from '../../shared/models/update-site-config.request';
import { UpdateSiteConfigurationRequest } from './update-site-configuration.request';

@Injectable({ providedIn: 'root' })
export class UpdateSiteConfigurationUseCase extends UseCase<UpdateSiteConfigurationRequest, Observable<HttpResponse<any>>> {
    private _apiRequestService = inject(ApiRequestService);
    private _configuratorBaseUrl = inject<string>('CONFIGURATOR_BASE_URL' as any);
    private _updateSiteConfigUrl = '/admin/update-siteconfig';

    constructor(_logService: LogService, _http: HttpClient) {
        super(_logService, _http);
    }

    protected override executeBusinessLogic(
        request: UpdateSiteConfigurationRequest | void
    ): Observable<HttpResponse<any>> | void {
        const req = request as UpdateSiteConfigurationRequest;
        const siteConfig: SiteConfiguration = {
            configurationKey: req.configurationKey,
            configurationValue: req.configurationValue,
            active: req.active
        };
        const updateSiteConfigRequest: UpdateSiteConfigRequest = {
            siteConfigList: [siteConfig]
        };
        return this._apiRequestService.sendRequest<UpdateSiteConfigRequest, HttpResponse<any>>(
            this._configuratorBaseUrl,
            updateSiteConfigRequest,
            true,
            this._updateSiteConfigUrl,
            true
        );
    }
}
